<template>
	<div class="tooltip-link">
		<v-popover offset="16" :classes="['tooltip']" :show="true" :auto-hide="false" placement="auto">
			<a class="tooltip-target">{{ targetText }}</a>

			<template slot="popover">
				<slot></slot>
			</template>
		</v-popover>
	</div>
</template>

<script>
	export default {
		name: 'inc.tooltip',
		props: {
			targetText: {
				type: String,
				default: '?'
			}
		},
	}
</script>